import * as React from 'react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import { ReservationPane } from '../../atoms/reservations/ReservationPane';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './reservationCancelCompletePane.module.scss';

export const ReservationCancelCompletePane = () => (
    <ReservationPane styleName="pane" id="reservation-cancel-complete-pane">
        <div styleName="text">ご回答ありがとうございました。<br/>予約キャンセルが完了しました。</div>
        <div styleName="button-wrapper">
            <Button
                id="back-to-home-button"
                type="primary"
                size="m"
                disabled={false}
                onClick={() => GlobalStatesV3.routing.push(V3Routes.home())}
            >
                マイページへ戻る
            </Button>
        </div>
    </ReservationPane>
);
